module.exports = {
  documentsFolder: 'documents',
  photosFolder: 'photos',
  agentsPhotosFolder: 'photos/agent',
  contentPhotosFolder: 'photos/content'
};
